import { useQuery } from "@tanstack/react-query";
import { useWebRouter } from "~utils/next-router/use-web-router";
import { graphierQLNextClient } from "utils";
import { useGetCurrentAccountCache } from "~auth/queries/useGetCurrentAccount";
import {
	GetMapAccessMethodQuery,
	GetMapAccessMethodQueryVariables,
} from "~map-view/types/__generated/gql/graphql";

const query = /* GraphQL */ `
	query GetMapAccessMethod($id: ID!) {
		getMapAccessMethod(id: $id) {
			type
		}
	}
`;

export const getMapAccessMethodQueryKey = (id: string) => [
	"getMapAccessMethod",
	id,
];

export const useGetMapAccessMethod = (id: string) => {
	const { isLoading: isAccountLoading, data: account } =
		useGetCurrentAccountCache();

	return useQuery({
		enabled: !!id && !isAccountLoading,
		queryKey: getMapAccessMethodQueryKey(id),
		queryFn: () =>
			graphierQLNextClient<
				GetMapAccessMethodQuery,
				GetMapAccessMethodQueryVariables
			>({
				query,
				variables: { id },
				useKey: !account?._currentUserRole,
			}).then((res) => res.getMapAccessMethod),
	});
};

export const useGetCurrentMapAccessMethod = () => {
	const { _query } = useWebRouter();

	return useGetMapAccessMethod(_query.mapId!);
};
